import { get } from 'lodash'

export const getLocale = state => get(state, 'internationalization.locale', 'en-US')
